import PropTypes from 'prop-types';
import { selectField } from '@lib/form';
import DropDown from './DropDown';
import OptionList from './OptionList';
import Searchable from './Searchable';
import Segmented from './Segmented';

export default function SelectField(props) {
  const { variant } = props;

  const Component = VARIANTS[variant || 'dropDown'];

  if (!Component) {
    // The variant comes straight from a CMS enumeration, so an unmapped value is an
    // editorial choice, not a programming error — rendering a drop-down beats crashing
    // the whole page.
    console.warn(`[form] Select variant "${variant}" is not supported, falling back to "dropDown".`);
    return <DropDown {...props} />;
  }

  return <Component {...props} />;
}

const VARIANTS = {
  dropDown: DropDown,
  // Strapi offers this as a distinct option but it has never had its own renderer
  dropDownList: DropDown,
  optionList: OptionList,
  // Short option sets read better as one row of buttons, long ones as a filter — both are
  // the same CMS field type, chosen by the editor through `variant`.
  segmented: Segmented,
  searchable: Searchable,
};

SelectField.propTypes = {
  // eslint-disable-next-line react/require-default-props
  variant: PropTypes.oneOf(Object.keys(VARIANTS)),
};

SelectField.getDefaultValue = selectField.getDefaultValue;
SelectField.serializeValue = selectField.serializeValue;
SelectField.deserializeValue = selectField.deserializeValue;
SelectField.getDisplayValue = selectField.getDisplayValue;
SelectField.validationSchema = selectField.validationSchema;
SelectField.graphQlSchema = `
typeSelect {
  id
  isMultiple
  minOptions
  maxOptions
  variant
  options(pagination: { limit: 100 }) {
    id
    label
    value
    badge
    image {
      data {
        id
        attributes {
          url
          formats
          hash
          height
          width
          name
          previewUrl
        }
      }
    }
  }
}
`;
